// Orpheus's on/off answer for a host that offers an Orpheus path (the Alerts page's "New"): whether
// the account has it off, and who can turn it on — so a locked path is never shown first and
// refused after (KUR-9). A facade over the shared consent store; hosts never reach the store.
import { computed, type ComputedRef } from 'vue'

import { useOrpheusConsentStore } from '../stores/orpheusConsentStore'

import { useAccount, useWorkspace } from '@/features/account'

export interface UseOrpheusConsentGate {
  /** Known to be off — never true on a guess. */
  isOff: ComputedRef<boolean>
  /** Who a member can ask, by name (or email). */
  adminNames: ComputedRef<string[]>
  load: () => Promise<void>
}

export function useOrpheusConsentGate(): UseOrpheusConsentGate {
  const store = useOrpheusConsentStore()
  const { accountId } = useAccount()
  const { workspaceId } = useWorkspace()
  return {
    isOff: computed(() => store.isOff),
    adminNames: computed(() =>
      store.accountAdmins.map((admin) => admin.name || admin.email).filter(Boolean),
    ),
    load: () => store.fetchConsent(accountId.value, workspaceId.value),
  }
}
